import React from "react";
import { BeatLoader } from "react-spinners";
import CountUp from "react-countup";
import useStats from "../utils";
import "../coronaStats.css";
export const StatsStateWise = ({ url }) => {
  console.log(url);
  const { stats, loading, error } = useStats(url);
  if (loading) return <BeatLoader loading color="red" />;
  if (error) return <p>Error...</p>;
  //console.log(stats);
  return (
    <React.Fragment>
      <div
        className="stateWiseHolder"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          minHeight: "400px",

          flexWrap: "wrap"
        }}
      >
        <div className="box box1">
          <span></span>
          <div className="content">
            <h2>Confirmed Cases</h2>
            <h1>
              {!stats.confirmed.value ? (
                <BeatLoader loading color="black" />
              ) : (
                stats.confirmed.value
              )}
            </h1>
          </div>
        </div>
        <div className="box box2">
          <span></span>
          <div className="content">
            <h2>Deaths Cases</h2>
            <h1>
              {!stats.deaths.value ? (
                <BeatLoader loading color="black" />
              ) : (
                stats.deaths.value
              )}
            </h1>
          </div>
        </div>
        <div className="box box3">
          <span></span>
          <div className="content">
            <h2>Recovered Cases </h2>
            <h1>
              {!stats.recovered.value ? (
                <BeatLoader loading color="black" />
              ) : (
                stats.recovered.value
              )}
            </h1>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default StatsStateWise;
